import React, { useState } from 'react';
import { Shield, Crosshair, Users } from 'lucide-react';

const DroneHeads = () => {
  const [activeHead, setActiveHead] = useState('anti-drone');

  const heads = [
    {
      id: 'anti-drone',
      name: 'Anti-Drone',
      icon: Shield,
      color: '#00A8E8',
      description: 'Intercept & neutralize hostile UAVs',
      specs: ['RF Jamming', 'Net Capture', 'Kinetic Impact']
    },
    {
      id: 'anti-tank',
      name: 'Anti-Tank',
      icon: Crosshair,
      color: '#FF6B35',
      description: 'Precision armor penetration',
      specs: ['Tandem Warhead', 'Top-Attack', 'Smart Targeting']
    },
    {
      id: 'anti-personnel',
      name: 'Anti-Personnel',
      icon: Users,
      color: '#D4AF37',
      description: 'Crowd control & suppression',
      specs: ['Fragmentation', 'Area Denial', 'Non-Lethal Options']
    }
  ];

  const activeHeadData = heads.find(h => h.id === activeHead);
  const Icon = activeHeadData.icon;

  return (
    <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
      {/* Title */}
      <div style={{ textAlign: 'center', marginBottom: '60px' }}>
        <div style={{ fontSize: '11px', color: '#D4AF37', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '16px' }}>
          MODULAR PAYLOADS
        </div>
        <h3 style={{ fontSize: '48px', fontWeight: '700', color: '#FFFFFF', marginTop: '16px' }}>
          Interchangeable Mission Heads
        </h3>
      </div>

      {/* Selector */}
      <div style={{ display: 'flex', justifyContent: 'center', gap: '40px', marginBottom: '60px', flexWrap: 'wrap' }}>
        {heads.map((head) => {
          const HeadIcon = head.icon;
          const isActive = activeHead === head.id;
          return (
            <div
              key={head.id}
              onClick={() => setActiveHead(head.id)}
              style={{
                padding: '32px 24px',
                border: `2px solid ${isActive ? head.color : 'rgba(212, 175, 55, 0.2)'}`,
                background: isActive ? 'rgba(212, 175, 55, 0.05)' : '#000000',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                minWidth: '200px',
                textAlign: 'center'
              }}
            >
              <div style={{
                width: '80px',
                height: '80px',
                margin: '0 auto 20px',
                border: `2px solid ${head.color}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.3s ease',
                transform: isActive ? 'scale(1.1)' : 'scale(1)'
              }}>
                <HeadIcon size={32} style={{ color: head.color }} />
              </div>
              <div style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#FFFFFF',
                textTransform: 'uppercase',
                letterSpacing: '1px'
              }}>
                {head.name}
              </div>
            </div>
          );
        })}
      </div>

      {/* Details */}
      <div style={{
        background: '#000000',
        border: '1px solid rgba(212, 175, 55, 0.2)',
        padding: '60px'
      }}>
        <div style={{
          display: 'flex',
          gap: '80px',
          alignItems: 'center',
          maxWidth: '1000px',
          margin: '0 auto',
          flexWrap: 'wrap',
          justifyContent: 'center'
        }}>
          {/* Visual */}
          <div style={{ position: 'relative', flexShrink: 0 }}>
            <div style={{
              width: '200px',
              height: '200px',
              border: `3px solid ${activeHeadData.color}`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'rgba(0, 0, 0, 0.5)',
              position: 'relative',
              zIndex: 2
            }}>
              <Icon size={64} style={{ color: activeHeadData.color }} />
            </div>
            <div style={{
              position: 'absolute',
              width: '300px',
              height: '300px',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              background: `radial-gradient(circle, ${activeHeadData.color}33 0%, transparent 70%)`,
              zIndex: 1
            }}></div>
          </div>
          
          {/* Info */}
          <div style={{ flex: 1, minWidth: '300px' }}>
            <h4 style={{
              fontSize: '32px',
              fontWeight: '700',
              marginBottom: '16px',
              color: activeHeadData.color
            }}>
              {activeHeadData.name} Configuration
            </h4>
            <p style={{
              fontSize: '18px',
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '32px',
              lineHeight: '1.6'
            }}>
              {activeHeadData.description}
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
              {activeHeadData.specs.map((spec, idx) => (
                <div key={idx} style={{
                  padding: '8px 16px',
                  background: 'rgba(212, 175, 55, 0.1)',
                  border: '1px solid rgba(212, 175, 55, 0.3)',
                  color: '#D4AF37',
                  fontSize: '12px',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '1px'
                }}>
                  {spec}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DroneHeads;